<!-- Header-section -->
<!-- <div class=" bg-black">
    <div class="col-md-7 img-svg" routerLink="/auth">
        <div class="w-161 marg-lft">
            <a [innerHTML]="svgContent" href="#"></a>
        </div>
    </div>
</div> -->


<!-- 404 error -->
<div class="container error-page-background">
    <div class="background-text">
        <h1 class="rotate-404">404</h1>
    </div>
    <div class="error-text">
        <p style="font-family: Lexend Deca;" class="text"> <strong>Oops! The page you are looking for seems to be
                missing.</strong>
            Please check the URL or return to the homepage</p>
        <div>
            <button class="btton custom-button" (click)="onBackButtonClick()">Back</button>
        </div>
    </div>